import { useChat } from "@ai-sdk/react";
import {
  ExpandableChatBody,
  ExpandableChatFooter
} from "@cmp-src/primitives/chat/expandable-chat";
import { useAskTessa } from "@cmp-src/tessa/AskTessaProvider";
import type { FileUIPart } from "ai";
import React from "react";
import { ChatBotConversation } from "@/features/tessa/components/ChatBotConversation";
import { ChatBotPromptInput } from "@/features/tessa/components/ChatBotPromptInput";
import { ChatBotSidebar } from "@/features/tessa/components/ChatBotSidebar";

export const ChatBotBubbleBody: React.FC<{
  popupSidebarOpen: boolean;
  setPopupSidebarClosed: () => void;
  chat: ReturnType<typeof useChat>;
}> = ({ popupSidebarOpen, setPopupSidebarClosed, chat }) => {
  const { selectedChatId, setSelectedChatId } = useAskTessa() || {
    selectedChatId: undefined,
    setSelectedChatId: () => {}
  };

  const { messages, sendMessage } = chat;
  const handleSubmit = (_: string, text: string, photos: FileUIPart[]) => {
    if (!text.trim() && photos.length === 0) {
      return;
    }

    sendMessage({ text: text.trim(), files: photos });
  };
  return (
    <>
      <ExpandableChatBody className={"relative"}>
        {popupSidebarOpen && (
          <ChatBotSidebar isBubble setPopupClosed={setPopupSidebarClosed} />
        )}
        {selectedChatId && !popupSidebarOpen && (
          <ChatBotConversation
            key={
              selectedChatId === "new"
                ? `new-${chat.id || "pending"}`
                : selectedChatId
            }
            chatId={selectedChatId === "new" ? chat.id || "" : selectedChatId}
            isThinking={chat.status !== "ready"}
            liveMessages={messages}
            isBubble
          />
        )}
      </ExpandableChatBody>
      {selectedChatId && !popupSidebarOpen && (
        <ExpandableChatFooter>
          <ChatBotPromptInput
            className={"border-1 border-primary-300"}
            handleSubmit={handleSubmit}
            isCompact
          />
        </ExpandableChatFooter>
      )}
    </>
  );
};
